import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { CurrencyMode } from "@/lib/currency";

/** Tres vistas: `grid` tarjetas grandes, `compact` cuadrícula 2 columnas, `list` lista. */
export type ViewMode = "grid" | "compact" | "list";

/**
 * Preferencias de visualización del catálogo y repuestos:
 * moneda (DOP/USD/ORIGINAL), modo de precio (total/inicial) y modo de vista.
 * Compartidas entre el menú del header, la barra lateral y las páginas.
 */
interface CatalogPrefsState {
  currency: CurrencyMode;
  showInitialPrice: boolean;
  viewMode: ViewMode;
  setCurrency: (currency: CurrencyMode) => void;
  setShowInitialPrice: (value: boolean) => void;
  toggleInitialPrice: () => void;
  setViewMode: (mode: ViewMode) => void;
}

export const useCatalogPrefs = create<CatalogPrefsState>()(
  persist(
    (set) => ({
      currency: "ORIGINAL",
      showInitialPrice: false,
      viewMode: "grid",
      setCurrency: (currency) => set({ currency }),
      setShowInitialPrice: (showInitialPrice) => set({ showInitialPrice }),
      toggleInitialPrice: () =>
        set((s) => ({ showInitialPrice: !s.showInitialPrice })),
      setViewMode: (viewMode) => set({ viewMode }),
    }),
    { name: "oriental-ramirez-catalog-prefs" }
  )
);
